module.exports = __webpack_public_path__ + "static/media/luxurybar1.0bea55d0.jpg";